import { useQuery } from '@tanstack/react-query';
import { IDocument } from '../@types/Document';
import { fetchQueries } from '../api/queries.api';

export function useSavedQueries(params) {
    const { data, ...rest } = useQuery({
        queryFn: () => fetchQueries(params),
        queryKey: ['saved-queries', params],
        refetchOnWindowFocus: false,
    });

    return {
        savedQueries: data?.items || ([] as IDocument[]),
        totalPages: data?.pages,
        ...rest,
    };
}
